import type { ItemUI } from '@libs/common-node';
import { DeliveryType } from '@libs/core';

export const buildFulfillmentMethodLabel = (fulfillmentMethod: string, item: ItemUI): string => {
    const rawMethod = fulfillmentMethod?.trim().toLowerCase();

    const method = rawMethod === DeliveryType.AUTOSHIP ? DeliveryType.STH : rawMethod;

    return [method, item.autoshipFrequency ? 'autoship' : 'one-time', item.scheduledDeliveryDate ? 'scheduled' : '']
        .join(' ')
        .trim();
};
